import { useEffect, useState } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Login from "../pages/login";
import PageNotFound from "../pages/not-found";
import ForgotPassword from "../pages/forgot-password";
import ResetPassword from "../pages/reset-password";
import protectRoutes from "./protected";
import TwoFactorAuthentication from "../pages/two-factor-verify";
import CreateAccount from "../pages/create-account";
import storage from "../helpers/storage";
import AuthGuard from "./handler/auth-guard";
import { useAuthStore } from "../redux/auth-store";
import { DEFAULT_AUTH_HOME } from "../constants/routes";
import PageLoader from "../components/common/PageLoader";
import { hasValidSession } from "../utils/session";

function AppRoutes() {
  const storeToken = useAuthStore((s) => s.token);
  const [hydrated, setHydrated] = useState(
    () => useAuthStore.persist.hasHydrated(),
  );

  useEffect(() => {
    if (useAuthStore.persist.hasHydrated()) {
      setHydrated(true);
      return;
    }
    return useAuthStore.persist.onFinishHydration(() => setHydrated(true));
  }, []);

  useEffect(() => {
    if (hasValidSession() && !storeToken) {
      useAuthStore.getState().setToken("true");
    }
  }, [storeToken]);

  const token =
    hydrated && !!(storeToken || storage.getToken());

  const router = [
    {
      path: "",
      element: <Navigate to={DEFAULT_AUTH_HOME} replace />,
    },
    {
      path: "login",
      element: (
        <AuthGuard>
          <Login />
        </AuthGuard>
      ),
    },
    {
      path: "create-account",
      element: (
        <AuthGuard>
          <CreateAccount />
        </AuthGuard>
      ),
    },
    {
      path: "two-factor-authentication",
      element: (
        <AuthGuard>
          <TwoFactorAuthentication />
        </AuthGuard>
      ),
    },
    {
      path: "forgot-password",
      element: (
        <AuthGuard>
          <ForgotPassword />
        </AuthGuard>
      ),
    },
    {
      path: "reset-password/:token",
      element: (
        <AuthGuard>
          <ResetPassword />
        </AuthGuard>
      ),
    },
    {
      path: "*",
      element: <PageNotFound />,
    },
  ];

  const mainRoutes = token ? protectRoutes : [];
  const routes = useRoutes([...router, ...mainRoutes]);

  if (!hydrated) {
    return <PageLoader message="Starting session..." />;
  }

  return <>{routes}</>;
}

export default AppRoutes;
